import { ApplicationRoutes } from '../../../app-routes-names'

export const VendorsRoutes = {
  summary: 'summary',
  levels: 'levels',
  preferred: 'preferred',
  preferredDetail: 'preferred/:locationId',
  list: 'list'
}

const { vendors } = ApplicationRoutes

export const VendorsPaths = {
  summary: `/${vendors}/${VendorsRoutes.summary}`,
  levels: `/${vendors}/${VendorsRoutes.levels}`,
  preferred: `/${vendors}/${VendorsRoutes.preferred}`,
  preferredDetail: (locationId: string) => `/${vendors}/${VendorsRoutes.preferred}/${locationId}`,
  list: `/${vendors}/${VendorsRoutes.list}`
}
